// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"768","tabletWidth":"1025"};